export default "<p-card>\r\n  <h3>QuizME</h3>\r\n  <router-outlet></router-outlet>\r\n</p-card>\r\n"